import { Avatar, AvatarGroup, HStack, Text } from '@chakra-ui/react'
import type { PrescriberProfile } from '../../../types/location'
import { getAvatarColorById } from '../constants/avatarColors'

interface PrescriberAvatarGroupProps {
  prescribers: PrescriberProfile[]
  max?: number
}

export const PrescriberAvatarGroup = ({ prescribers, max = 5 }: PrescriberAvatarGroupProps) => {
  return (
    <HStack spacing={3}>
      <AvatarGroup size="xs" max={max} spacing="-6px">
        {prescribers.map((prescriber) => (
          <Avatar
            key={prescriber.id}
            name={`${prescriber.givenNames} ${prescriber.familyName}`}
            bg={getAvatarColorById(prescriber.prescriberId)}
            color="white"
            fontSize="xs"
            fontWeight="bold"
          />
        ))}
      </AvatarGroup>
      <Text fontSize="sm" color="gray.600">
        {prescribers.length} assigned
      </Text>
    </HStack>
  )
}
